import view from '../../view';
import constants from '../constants';
import getParentGlobalElement from '../helpers/get-parent-global-element';
import getDetachedChildrenArray from '../helpers/get-detached-children-array';
import getGlobalBySource from '../selectors/global-by-source';

const { actionTypes, attributes } = constants;

const detachGlobal = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.DETACH_GLOBAL: {
      const state = store.getState();
      const { globalElement: liveGlobalElement } = action.payload;

      const globalElementId = view.accessors.getLiveElementId(liveGlobalElement);
      const globalElement = view.accessors.getStaticElement(globalElementId);

      globalElement.setAttribute(attributes.DETACHED_GLOBAL, true);

      let elementToReplace = globalElement;
      let parentGlobalElement = getParentGlobalElement(globalElement);

      while (parentGlobalElement) {
        const previouslyDetachedChildrenArray = getDetachedChildrenArray(parentGlobalElement);

        const childSource = elementToReplace.getAttribute('src');
        const { id: detachedChildName } = getGlobalBySource(state, childSource);

        parentGlobalElement.setAttribute(
          attributes.DETACHED_CHILDREN_GLOBAL,
          [...new Set([...previouslyDetachedChildrenArray, detachedChildName])].join(' ')
        );

        elementToReplace = parentGlobalElement;
        parentGlobalElement = getParentGlobalElement(parentGlobalElement);
      }

      const liveElementToReplace = view.accessors.getLiveElementByStaticElement(elementToReplace);
      const elementToReplaceId = view.accessors.getLiveElementId(liveElementToReplace);

      view.operations.replaceElement(elementToReplace, elementToReplaceId);

      next(action);
      break;
    }

    default:
      next(action);
  }
};

export default detachGlobal;
